export default function SuspenseFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center text-cocoa">
      Loading...
    </div>
  );
}
